import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import ToggleField from '../../ToggleField/ToggleField';

import logo from '../../../assets/images/integrations/eventival.webp';

const EventivalFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="EventivalFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" alt={t('settings.integrations.eventival.title')} />
                                { t('settings.integrations.eventival.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                        <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.eventival.name")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.eventival.name" id="name" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.eventival.year")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.eventival.year" id="year" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.eventival.api_key")}</Label>
                                            <Col lg={10} >
                                                <Field required component="input" className="form-control" type="text" name="integrations.eventival.api_key" id="api_key" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>

                        <CardBody>
                            <CardTitle className="small">{ t('settings.integrations.eventival.import.screenings.title') }</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.eventival.import.screenings.enabled")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.eventival.import.screenings.enabled" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.eventival.import.screenings.delete_future")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.eventival.import.screenings.delete_future" />
                                            </Col>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""} >{t("settings.integrations.eventival.import.screenings.delete_existing")}</Label>
                                            <Col lg={1} >
                                                <ToggleField name="integrations.eventival.import.screenings.delete_existing" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.eventival.import.screenings.fullfill_people")}</Label>

                                            <Col lg={1} >
                                            <ToggleField name="integrations.eventival.import.screenings.fullfill_people" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                            <CardTitle className="small">{ t('settings.integrations.eventival.import.tickets.title') }</CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={3} className={ !isMobile && !isTablet ? "text-right" : ""}>{t("settings.integrations.eventival.import.tickets.enabled")}</Label>

                                            <Col lg={1} >
                                                <ToggleField name="integrations.eventival.import.tickets.enabled" />
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default EventivalFields;
